import { render, staticRenderFns } from "./FDReceipt.vue?vue&type=template&id=bce0494e&scoped=true"
import script from "./FDReceipt.vue?vue&type=script&lang=js"
export * from "./FDReceipt.vue?vue&type=script&lang=js"
import style0 from "./FDReceipt.vue?vue&type=style&index=0&id=bce0494e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce0494e",
  null
  
)

export default component.exports